













import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({})
export default class NotFound extends Vue {
    @Prop({default: 'page'})
    name!: string;
}

